import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// resources (inlined for Phase B bootstrap; can be split into files later)
import en_common from './locales/en/common.json';
import en_cta from './locales/en/cta.json';
import en_legal from './locales/en/legal.json';
import en_marketing from './locales/en/marketing.json';
import es_common from './locales/es/common.json';
import es_cta from './locales/es/cta.json';
import es_legal from './locales/es/legal.json';
import es_marketing from './locales/es/marketing.json';
import ptBr_common from './locales/pt-BR/common.json';
import ptBr_cta from './locales/pt-BR/cta.json';
import ptBr_legal from './locales/pt-BR/legal.json';
import ptBr_marketing from './locales/pt-BR/marketing.json';
import pt_common from './locales/pt/common.json';
import pt_cta from './locales/pt/cta.json';
import pt_legal from './locales/pt/legal.json';
import pt_marketing from './locales/pt/marketing.json';
import ru_common from './locales/ru/common.json';
import ru_cta from './locales/ru/cta.json';
import ru_legal from './locales/ru/legal.json';
import ru_marketing from './locales/ru/marketing.json';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: en_common, cta: en_cta, legal: en_legal, marketing: en_marketing },
      es: { common: es_common, cta: es_cta, legal: es_legal, marketing: es_marketing },
      'pt-BR': {
        common: ptBr_common,
        cta: ptBr_cta,
        legal: ptBr_legal,
        marketing: ptBr_marketing,
      },
      pt: { common: pt_common, cta: pt_cta, legal: pt_legal, marketing: pt_marketing },
      ru: { common: ru_common, cta: ru_cta, legal: ru_legal, marketing: ru_marketing },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'es', 'pt-BR', 'pt', 'ru'],
    ns: ['common', 'cta', 'legal', 'marketing'],
    defaultNS: 'common',
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lng',
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
    react: {
      useSuspense: false, // Disable suspense to prevent white screen
    },
  });

export default i18n;